var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_html.js
// module id = 352
// module chunks = 168707334958949